import { SxProps, Theme, styled, useTheme } from '@mui/material/styles';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
  Typography,
} from '@mui/material';
import { useField } from 'formik';
import { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useFieldRequired } from './FormSchemaContext';


export const BootstrapSelect = styled(Select)(({ theme }) => ({
  // '&.MuiInputBase-root': {
  //   '& .MuiSelect-select': {
  //     // color: '#8692A6',
  //     border: '1px solid #DDEAF3',
  //     fontSize: 16,
  //     padding: '10px 12px',
  //     borderRadius: 4,
  //     // transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
  //     // '&:focus': {
  //     //   boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
  //     //   borderColor: theme.palette.primary.main,
  //     // },
  //   },
  // },
  // '.MuiOutlinedInput-notchedOutline': {
  //   borderWidth: '1px',
  //   borderStyle: 'solid',
  //   borderColor: '#DDEAF3',
  // },
  // '&.Mui-focused,&:hover': {
  //   '.MuiOutlinedInput-notchedOutline': {
  //     borderWidth: '1px',
  //     borderColor: theme.palette.primary.main,
  //   },
  // },
  // svg: {
  //   color: '#337FC9',
  // },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: "10px",
    backgroundColor: `${theme.palette.common.white}OD`,
    border: `0.5px solid ${theme.palette.text.secondary}80`,
  },
  "& .MuiSelect-select": {
    padding: "15px",
    "& span": {
      ...theme.typography.body_500,
      color: theme.palette.text.primary
    }
  },
  '&.Mui-focused': { color: theme.palette.primary[800] },
  svg: {
    color: theme.palette.text.primary,
  },
}));

export default function MFSelectField({
  name,
  label,
  items,
  onChange,
  disabled = false,
  indexing = false,
  applyLabelStyles = false,
  isCapitalize = false,
  dropdownOptionStyle = {},
  ...rest
}: SelectProps & {
  name: string;
  label?: string;
  items: { key: string | number; value: string | number }[];
  onChange?: (event: SelectChangeEvent<unknown>) => void;
  disabled?: boolean;
  indexing?: boolean;
  applyLabelStyles?: boolean;
  isCapitalize?: boolean;
  dropdownOptionStyle?: SxProps<Theme>;
}): JSX.Element {
  const id = `${name}-input`;
  const labelId = `${id}-label`;
  const errorId = `${name}-error`;
  const theme = useTheme();
  const [field, meta] = useField(name);
  onChange = onChange || field.onChange;
  const errorText = meta.error && meta.touched ? meta.error : '';
  const isRequired = useFieldRequired(name);
  const [isOpen, setIsOpen] = useState(false);
  const isControlledOpen = rest.open !== undefined;
  const expanded = isControlledOpen ? Boolean(rest.open) : isOpen;
  return (
    <FormControl fullWidth sx={{ my: { xs: 1, sm: 1, md: 2 } }}>
      {label && (
        <InputLabel
          // shrink
          htmlFor={labelId}
          sx={(theme: Theme) => ({
            // transform: 'unset',
            // fontSize: 14,
            // fontWeight: 500,
            // color: 'rgba(0,0,0,0.7)',
            whiteSpace: applyLabelStyles ? 'normal' : 'nowrap',
            // position: applyLabelStyles ? 'relative' : 'absolute',
            color: disabled ? `${theme.palette.text.secondary}4D` : theme.palette.text.secondary,
            ...theme.typography.body_500,
              '&.Mui-focused': {
                color: theme.palette.primary[700],
              },
           
          })}
        >
          {label}
        </InputLabel>
      )}
      <BootstrapSelect
        labelId={labelId}
        label={label}
        id={id}
        sx={{
          // mt: applyLabelStyles ? '10px' : '32px',
          ...rest.sx,
          '& .Mui-disabled': {
            cursor: !disabled ? 'pointer' : 'not-allowed !important',
            pointerEvents: 'all',
          },
        }}
        MenuProps={{
          sx: {
            '.MuiPaper-root ': {
              maxWidth: { xs: '100%', sm: '31%', md: '26%' },
              maxHeight: '20%',
              minWidth: 'fit-content',
              overflowX: 'auto',
            },
          },
          MenuListProps: {
            autoFocusItem: true,
          },
        }}
        placeholder="ssss"
        IconComponent={ExpandMoreIcon}
        {...field}
        {...rest}
        onOpen={(event) => {
          if (!isControlledOpen) setIsOpen(true);
          rest.onOpen?.(event);
        }}
        onClose={(event) => {
          if (!isControlledOpen) setIsOpen(false);
          rest.onClose?.(event);
        }}
        SelectDisplayProps={{
          'aria-expanded': expanded,
          'aria-labelledby': label ? labelId : undefined,
          'aria-label': label ?? '',
          'aria-invalid': errorText ? true : undefined,
          'aria-describedby': errorText ? errorId : undefined,
          'aria-required': isRequired || undefined,
          ...(rest.SelectDisplayProps || {}),
        }}
        onChange={onChange}
        disabled={disabled}>
        {items?.map((item, index: number) => (
          <MenuItem
            key={`${item.key}-${index}`}
            value={item.value}
            sx={(theme: Theme) => ({
              // fontSize: 14,
              // fontWeight: 500,
              ...theme.typography.body_500,
              color: theme.palette.text.primary,
              // '&.Mui-selected,&.Mui-selected:hover': { backgroundColor: 'unset' },
              // '&.Mui-selected': { display: 'none' },
            })}>
            {indexing ? (
              <>
                <Typography
                  variant='body_500'
                  sx={{
                    color: 'text.primary',
                    // fontWeight: 500, 
                    // fontSize: 14 
                  }}
                  component="span">
                  C{index < 9 ? '0' + (index + 1) : index + 1}
                </Typography>
                <Typography
                  variant='body_500'
                  sx={{
                    // fontSize: 14,
                    // fontWeight: 500,
                    ...(isCapitalize ? { textTransform: 'capitalize' } : {}),
                    color: 'text.primary',
                    '&.Mui-selected,&.Mui-selected:hover': { backgroundColor: 'unset' },
                    ...dropdownOptionStyle
                  }}
                  component="span">
                  {isCapitalize ?
                    (typeof item?.key === "string" ? item?.key?.toLowerCase() : item?.key)
                    : item?.key}
                  {/* {item.key} */}
                </Typography>
              </>
            ) : (
              <Typography
                sx={{
                  whiteSpace: { xs: 'pre-wrap', sm: 'nowrap' },
                  ...(isCapitalize ? { textTransform: 'capitalize' } : {}),
                  ...dropdownOptionStyle
                }}
                component="span"
              >
                {/* {item.key} */}
                {isCapitalize ?
                  (typeof item?.key === "string" ? item?.key?.toLowerCase() : item?.key)
                  : item?.key}
              </Typography>
            )}
          </MenuItem>
        ))}
      </BootstrapSelect>
      {errorText && (
        <FormHelperText
          error
          id={errorId}
          role="alert"
          sx={{ marginLeft: 'unset', color: `${theme.palette.error[900]}`, fontWeight: 500 }}
        >
          {errorText}
        </FormHelperText>
      )}
    </FormControl>
  );
}
